import { IThread } from '@fly/shared';

export interface ThreadGroup {
  labelKey: string;
  defaultLabel: string;
  threads: IThread[];
}

export function groupThreadsByDate(threads: IThread[]): ThreadGroup[] {
  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const oneWeekAgo = new Date(startOfToday.getTime() - 7 * 24 * 60 * 60 * 1000);

  const today: IThread[] = [];
  const pastWeek: IThread[] = [];
  const older: IThread[] = [];

  for (const thread of threads) {
    const date = new Date(thread.updated_at);
    if (date >= startOfToday) {
      today.push(thread);
    } else if (date >= oneWeekAgo) {
      pastWeek.push(thread);
    } else {
      older.push(thread);
    }
  }

  const groups: ThreadGroup[] = [];
  if (today.length > 0) {
    groups.push({
      labelKey: 'app.dashboard.chat.history.group.today',
      defaultLabel: 'Today',
      threads: today,
    });
  }
  if (pastWeek.length > 0) {
    groups.push({
      labelKey: 'app.dashboard.chat.history.group.past_week',
      defaultLabel: 'Past Week',
      threads: pastWeek,
    });
  }
  if (older.length > 0) {
    groups.push({
      labelKey: 'app.dashboard.chat.history.group.older',
      defaultLabel: 'Older',
      threads: older,
    });
  }
  return groups;
}
